import React from 'react';

const formatNumber = (num, digits = 2) => {
  if (num === null || num === undefined || Number.isNaN(Number(num))) return '—';
  return Number(num).toLocaleString('ru-RU', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
};

function MarginIndicatorsPanel({ marginIndicators, variant = 'default' }) {

  const data = marginIndicators?.data;
  const isAccountMobile = variant === 'account-mobile';

  const accountLabel = data ? (data.displayName || data.number || '—') : '—';
  const currentValueRub = data?.currentValueRub;
  const collateral = data?.collateral;
  const collateralAvailable = data?.collateralAvailable;
  const borrowedFunds = data?.borrowedFunds;
  const varMargin = data?.varMargin;

  const fontSize = isAccountMobile ? '1rem' : '0.85rem';
  const titleFontSize = isAccountMobile ? '1.125rem' : '1rem';
  const titleColor = 'var(--color-data-cyan)';

  return (
    <div
      className={`side-panel${isAccountMobile ? ' side-panel--account-mobile' : ''}`}
      style={{
        width: '100%',
        minHeight: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        padding: isAccountMobile ? '18px 20px' : '15px 20px',
      }}
    >
      <div
        style={{
          marginBottom: '10px',
          fontSize: titleFontSize,
          fontWeight: 'bold',
          textAlign: 'center',
          color: titleColor,
        }}
      >
        {accountLabel}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: isAccountMobile ? '10px' : '7px', fontSize }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px' }}>
          <span style={{ color: '#999' }}>Тек. стоимость</span>
          <span>{currentValueRub != null ? formatNumber(currentValueRub, 0) : '-'}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px' }}>
          <span style={{ color: '#999' }}>Доступно под ГО</span>
          <span>{collateralAvailable != null ? formatNumber(collateralAvailable, 0) : '-'}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px' }}>
          <span style={{ color: '#999' }}>Тек. ГО</span>
          <span>{collateral != null ? formatNumber(collateral, 0) : '-'}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px' }}>
          <span style={{ color: '#999' }}>Задолженности</span>
          <span>{borrowedFunds != null ? formatNumber(borrowedFunds, 0) : '-'}</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', gap: '12px' }}>
          <span style={{ color: '#999' }}>Вар. маржа</span>
          <span>{varMargin != null ? formatNumber(varMargin, 0) : '-'}</span>
        </div>
      </div>
    </div>
  );
}

export default MarginIndicatorsPanel;
